import { useNavigate, useParams } from 'react-router-dom';
import classNames from 'classnames';
import navConfig from './navConfig.json';

function ProfileNav({ category }) {
  const navigate = useNavigate();
  const { slug_2 } = useParams();

  // Kiểm tra nút cha có đang active không
  const isActiveParent = (parentItem) => {
    if (parentItem.children) {
      return parentItem.children.some(child => child.slug_2 === slug_2);
    }
    return parentItem.slug_2 === slug_2;
  };

  // Lọc các mục trong category
  const categoryConfig = navConfig.find(cat => cat.category === category);
  if (!categoryConfig) {
    return <div>Không tìm thấy danh mục: {category}</div>;
  }

  return (
    <div className="flex flex-col space-y-4">
      {/* Nút cha */}
      <div className="flex space-x-4 justify-center">
        {categoryConfig.items.map((item) => (
          <div
            key={item.slug_2}
            className={`text-xs lg:text-base rounded-md border-2 cursor-pointer px-2 py-1 ${classNames({
              "border-blue-600": item.slug_2 === slug_2 || (item.children && item.children.some(child => child.slug_2 === slug_2)),
            })}`}
            onClick={() => {
              if (item.path) {
                navigate(item.path);
              } else if (item.children && item.children.length > 0) {
                navigate(item.children[0].path); // Chuyển đến nút con đầu tiên nếu nút cha không có path
              }
            }}
          >
            {item.label}
          </div>
        ))}
      </div>

      {/* Nút con - Chỉ hiển thị khi nút cha đang active */}
      {categoryConfig.items.map((item) => (
        item.children && isActiveParent(item) && (
          <div key={item.slug_2} className="flex space-x-4 mt-2 justify-center w-full">
            {item.children.map((child) => (
              <div
                key={child.slug_2}
                className={`text-xs lg:text-base rounded-md border-2 cursor-pointer px-2 py-1 ${classNames({
                  "border-blue-600": child.slug_2 === slug_2,
                })}`}
                onClick={() => navigate(child.path)}
              >
                {child.label}
              </div>
            ))}
          </div>
        )
      ))}
    </div>
  );
}

export default ProfileNav;
